<div class="app-toast-region" aria-live="polite" aria-atomic="true">
  @for (message of feedback.messages(); track message.id) {
    <article class="app-toast" [class.success]="message.severity === 'success'" [class.error]="message.severity === 'error'">
      <div>
        <strong>{{ message.summary }}</strong>
        <span>{{ message.detail }}</span>
      </div>
      <button type="button" aria-label="Dismiss message" (click)="feedback.dismiss(message.id)">x</button>
    </article>
  }
</div>
<app-confirm-dialog />
<router-outlet />
